import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		style: { fill: "none" },
		d: "M0,0H13V13H0Z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon",
		d: "M2.533,3h9.6a.531.531,0,0,1,.533.528v8.444a.531.531,0,0,1-.533.528h-9.6A.531.531,0,0,1,2,11.972V3.528A.531.531,0,0,1,2.533,3ZM7.365,7.583,3.946,4.709l-.691.8,4.117,3.46,4.043-3.462-.7-.8L7.366,7.583Z",
		transform: "translate(-0.833 -1.25)"
	})]
});
export default SvgEmail;
